import { setInfoUser, setPays } from "../../redux/globalSlice";

// function loginUser() {}

export const getListPays = async (
    i18nextLng: string,
    dispatch: Function,
    fetchGlobal: <T>(url: string, options?: RequestInit) => Promise<T>
) => {
    let apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/pays`;
    try {
        const data: any = await fetchGlobal(apiUrl, {
            headers: {
                "Content-Type": "application/json",
                "Accept-Language": i18nextLng,
            },
            method: "GET",
        });

        if (data.error) {
            throw Error("Error!");
        }
        let listPays: any = [];

        data.data.forEach((element: any) => {
            listPays.push({
                code: element.code,
                label: element["Designation"],
                value: element.Id,
                frDesignation: element.frenchDesignation,
            });
        });
        dispatch(setPays(listPays));
    } catch (error) {
        console.log("error fetching pays : ", error);
    }
};

export async function processSuccessfulLogin(
    response: any,
    email: string,
    dispatch: Function
) {
    const { data } = response;
    localStorage.setItem("Uid_Entitie_User", data.uidentitie);
    localStorage.setItem("uuidUser", data.uuiduser);
    dispatch(
        setInfoUser({
            ...response.data,
            maincolor: data.maincolor?.trim() || "#292929",
            secondarycolor: data.secondarycolor?.trim() || "#292929",
            email,
        })
    );
}
